const SATELLITE_STYLE = "mapbox://styles/bfgneil/clzjpuk4o00lc01qy302x2slj";

/**
 * Named roadmap style presets shared across map components.
 *
 * - `branded`: the Trackpac custom Mapbox styles (used by device-centric maps).
 * - `standard`: stock Mapbox streets/dark styles (used by overview maps).
 */
export const MAP_STYLES = {
  branded: {
    light: "mapbox://styles/bfgneil/cm6gclmw8003501s31vcx94z8",
    dark: "mapbox://styles/bfgneil/cm6gcmt5l00ck01r56spcffre",
  },
  standard: {
    light: "mapbox://styles/mapbox/streets-v12",
    dark: "mapbox://styles/mapbox/dark-v11",
  },
};

/**
 * Returns the appropriate Mapbox style URL based on the user's map style
 * preference and the current theme mode.
 *
 * @param {string} themeMode - "light" or "dark"
 * @param {{ light: string, dark: string }} [roadmapStyles] - optional per-component overrides
 * @returns {string} Mapbox style URL
 */
export function getMapStyle(
  themeMode,
  roadmapStyles = {
    light: "mapbox://styles/mapbox/streets-v11",
    dark: "mapbox://styles/mapbox/dark-v10",
  }
) {
  const preference = localStorage.getItem("map_style") || "roadmap";

  if (preference === "satellite") {
    return SATELLITE_STYLE;
  }

  return themeMode === "light" ? roadmapStyles.light : roadmapStyles.dark;
}
